/**
 * CONTEXT AND REDUCER
 *  SCOPE: 
 *  1. STORE OBJECT LIST GLOBALY
 *  2. UPDATE OBJECT LIST GLOBALY
 */

import {createContext, useContext, useReducer } from "react";

 export const ObjListContext         = createContext([]);
 export const ObjListDispatchContext =  createContext(null);


 export function ObjListProvider({children}) {

    // let initState = [];

    let initState = {
        data: [],
        hasMore:true,
        page:1
    }

    const [objectList, dispatch] = useReducer( objListReducer, initState);

    return(
        <ObjListContext value={objectList}>
            <ObjListDispatchContext value={dispatch}>
                {children}
            </ObjListDispatchContext>
        </ObjListContext>
    )
 }

//  reference functions
export function useObjList()         { return useContext(ObjListContext); }
export function useObjListDispatch() { return useContext(ObjListDispatchContext); }


function objListReducer(objectList, oAction) {

    let nObjList;

    switch(oAction.type) {

        case 'setList':

            if(oAction.reason === 'load') {
                nObjList = {...objectList, 
                                data : [...objectList.data, ...oAction.data['result']],
                                hasMore: oAction.data['hasMore'], 
                            }; // hasMore: oAction.hasMore
            }

            // when the action comes from filter. 
            // paging should be reset to 1. and data set should be reseted
            if(oAction.reason === 'filter') { 
                nObjList = {...objectList, 
                                data : oAction.data['result'],
                                hasMore: oAction.data['hasMore'], 
                                page:1
                            };
            }

        break;

        case 'incrPage':
            nObjList = {...objectList,  page : objectList.page + 1 };
        break;

        default: //
    }

    return(nObjList);
}


